<template>
  <!-- <van-checkbox
    :name="`${value.row}-${value.column}`"
    :class="[
      value.status === 0 ? 'blank' : '',
      value.status === 2 ? 'sold van-checkbox__icon--checked' : '',
    ]"
    :disabled="value.status !== 1"
    :icon-size="26"
  /> -->
  <van-checkbox
    :name="`${value.row}-${value.column}`"
    :disabled="value.status !== 1"
    :icon-size="40"
  >
    <template #icon="props">
      <!-- 下面是可选 状态都是1 -->
      <img v-if="value.status==1" class="img-icon" :src="props.checked ? selectIcon : optionalIcon" />
      <!-- 下面是不可选 包括已售和座位损坏 状态为2 -->
      <img v-if="value.status==2" class="img-icon" :src="soldIcon" />
      <!-- 空座 状态为0 -->
      <img v-if="value.status==0" class="img-icon" :src="emptyIcon" />
    </template>
  </van-checkbox>
</template>
<script>
import selectIcon from '@/assets/img/selected.png'
import optionalIcon from '@/assets/img/optional.png'
import soldIcon from '@/assets/img/sold.png'
import emptyIcon from '@/assets/img/empty.png'

export default {
  props: {
    value: [Object],
    text: [String],
  },
  data() {
    return {
      checked: true,
      selectIcon,
      optionalIcon,
      soldIcon,
      emptyIcon
    };
  },
};
</script>
<style lang="less" scoped>
.van-checkbox {
  margin: 1px;
  display: inline-block;
  &.blank {
    visibility: hidden;
  }
  &.sold[aria-checked='false'] /deep/.van-icon {
    background: red;
    border-color: red;
  }
  &[aria-checked='false'] /deep/.van-icon {
    border-color: #999;
  }
}
.img-icon {
  height: 100%;
}
</style>
